export enum TABS {
  SUMMARY = 'summary',
  ACTIVITIES = 'activities',
  HISTORY = 'history',
  RECORD = 'record',
}
